import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles({ name: 'ConfiguratorBanner' })((theme) => ({
	root: {
		position: 'relative'
	},
	'layer-0': {
		position: 'absolute',
		right: 0,
		top: 0,
		bottom: 0,
		left: 0
	},
	'layer-1': {
		position: 'absolute',
		display: 'none'
	},
	'layer-2': {
		position: 'absolute'
	},
	content: {
		position: 'relative'
	}
}));

export const useStylesMobile = makeStyles({ name: 'ConfiguratorBannerMobile' })(({ Skoda: { settings: { bannerConfigurator: { colors } } } }) => ({
	'layer-0': {
		background: `radial-gradient(232.98% 73.64% at 94.97% 26.36%, ${colors[0]} 0%, ${colors[1]} 100%)`
	},
	'layer-1': {
		left: '0',
		right: '0',
		bottom: '0',
		top: '50%',
		background: `radial-gradient(50% 196.85% at 50% 24.41%, ${colors[0]} 0%, ${colors[1]} 100%)`
	},
	'layer-2': {
		display: 'none',
		background: `linear-gradient(0deg, ${colors[2]} 49.78%, rgba(217, 217, 217, 0) 100%)`
	}
}));

export const useStylesDesktop = makeStyles({ name: 'ConfiguratorBannerDesktop' })((theme) => {
	const { Skoda: { settings: { bannerConfigurator: { colors } } } } = theme;
	return ({
		'layer-0': {
			background: `radial-gradient(50% 196.85% at 50% 24.41%, ${colors[0]} 0%, ${colors[1]} 100%)`
		},
		'layer-1': {
			right: '0',
			top: '0',
			bottom: '0',
			left: '43.58%',
			[theme.breakpoints.up('xl')]: {
				left: '50%'
			},
			background: `radial-gradient(89.14% 73.64% at 36.34% 26.36%, ${colors[0]} 0%, ${colors[1]} 100%)`,
			clipPath: 'polygon(100% 0, 100% 100%, 0% 100%, 155px 50%, 0% 0%)',
			WebkitClipPath: 'polygon(100% 0, 100% 100%, 0% 100%, 155px 50%, 0% 0%)'
		},
		'layer-2': {
			right: '0',
			bottom: '0',
			left: '0',
			top: '75%',
			background: `linear-gradient(0deg, ${colors[2]} 49.78%, rgba(217, 217, 217, 0) 100%)`
		}
	});
});
